import { ResponseError } from "@lucaswickstrom/fetch";
import { MutationCache, QueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
    mutationCache: new MutationCache({
        async onError(error, _variables, _context, mutation) {
            if (mutation.meta?.error) {
                if (error instanceof ResponseError) {
                    const data = await error.response.clone().json();
                    // @ts-ignore
                    const message = data?.error?.message || error.message;
                    enqueueSnackbar(message, { variant: "error" });
                }
                else if (error instanceof Error) {
                    enqueueSnackbar(error.message, { variant: "error" });
                }
            }
        },
    }),
});
//# sourceMappingURL=queryClient.js.map